import React, { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import * as icons from "Assets/Icons";
import { searchOffersCount } from "Api/api";
import routes from "../routes";

const BlocksNav = (): JSX.Element => {
    const [count, setCount] = useState<number>(0);
    useEffect(() => {
        searchOffersCount().then(setCount);
    }, []);

    return (
        <section className={"rmxo-index rmxo-container"}>
            <h2 className={"rmxo-index-title"}>
                Nemovitosti na prodej a k pronájmu {count > 0 && ` - ${count} realit`}
            </h2>
            <div className={"rmxo-index-row"}>
                <div className={"rmxo-index-item"}>
                    <Link to={routes.flats} className={"rmxo-index-main-button"}>
                        <img src={icons.iconFlats} alt={"Byty"} className={"rmxo-index-icon"} />
                        Byty
                    </Link>
                    <Link to={`${routes.flats}-prodej`}>prodej bytů</Link>
                    <Link to={`${routes.flats}-pronajem`}>pronájem bytů</Link>
                </div>

                <div className={"rmxo-index-item"}>
                    <Link to={routes.houses} className={"rmxo-index-main-button"}>
                        <img src={icons.iconHouses} alt={"Domy a vily"} className={"rmxo-index-icon"} />
                        Domy a vily
                    </Link>
                    <Link to={`${routes.houses}-prodej`}>prodej domů</Link>
                    <Link to={`${routes.houses}-pronajem`}>pronájem domů</Link>
                </div>

                <div className={"rmxo-index-item"}>
                    <Link to={routes.lands} className={"rmxo-index-main-button"}>
                        <img src={icons.iconLands} alt={"Pozemky"} className={"rmxo-index-icon"} />
                        Pozemky
                    </Link>
                    <Link to={`${routes.lands}-prodej`}>prodej pozemků</Link>
                    <Link to={`${routes.lands}-pronajem`}>pronájem pozemků</Link>
                </div>
                <div className={"rmxo-index-item"}>
                    <Link to={routes.commercial} className={"rmxo-index-main-button"}>
                        <img src={icons.iconCommercial} alt={"Komerční nemovitosti"} className={"rmxo-index-icon"} />
                        Komerční nemovitosti
                    </Link>
                    <Link to={`${routes.commercial}-prodej`}>prodej komerčních</Link>
                    <Link to={`${routes.commercial}-pronajem`}>pronájem komerčních</Link>
                </div>

                <div className={"rmxo-index-item"}>
                    <Link to={routes.other} className={"rmxo-index-main-button"}>
                        <img src={icons.iconOther} alt={"Ostatní nemovitosti"} className={"rmxo-index-icon"} />
                        Ostatní
                    </Link>
                    <Link to={`${routes.other}-prodej`}>ostatní prodej</Link>
                    <Link to={`${routes.other}-pronajem`}>ostatní pronájem</Link>
                </div>
            </div>
        </section>
    );
};

type LinkProps = React.ComponentPropsWithoutRef<"a"> & { to: string };

const Link = ({ to, children, className, ...props }: LinkProps): JSX.Element => {
    if (window.rmxo_indexPage) {
        return (
            <a href={`${window.rmxo_indexPage}/${to}`} className={`${className} rmxo-index-button`} {...props}>
                {children}
            </a>
        );
    }
    return (
        <RouterLink to={`/${to}`} className={`${className} rmxo-index-button`} {...props}>
            {children}
        </RouterLink>
    );
};

export default BlocksNav;
